import { Producer } from "features/settings/producers/producer";
import Commodity from "./commodity";
import { DeliveryMethod } from "./deliveryMethod";
import PhysicalLocation from "./physicalLocation";

export default interface CommodityBalance {
    id: string;
    erpId: string;
    merchantId: string;
    commodityBalanceType: CommodityBalanceType;
    commodity: Commodity;
    producer: Producer;
    producerAccount: string;
    location: PhysicalLocation;
    quantity?: number;
    createdDate: Date;
    lastUpdatedDate: Date;
    lastErpSyncDate?: Date;
}

export enum CommodityBalanceType {
    OpenStorage = 1,
    DelayedPrice = 2,
    GrainBank = 3,
    WarehouseReceipts = 4,
    HouseReceipts = 5,
    ShortTermStorage = 6,
    FarmDirect = 7,
}

export const CommodityBalanceTypes: CommodityBalanceType[] = [
    CommodityBalanceType.OpenStorage,
    CommodityBalanceType.DelayedPrice,
    CommodityBalanceType.WarehouseReceipts,
    CommodityBalanceType.GrainBank,
    CommodityBalanceType.HouseReceipts,
    CommodityBalanceType.ShortTermStorage,
    CommodityBalanceType.FarmDirect
];


export function getCommodityBalanceType(deliveryMethod: Nullish<DeliveryMethod>): CommodityBalanceType | null {
    switch (deliveryMethod) {
        case DeliveryMethod.OpenStorage:
            return CommodityBalanceType.OpenStorage;
        case DeliveryMethod.DelayedPrice:
            return CommodityBalanceType.DelayedPrice;
        case DeliveryMethod.GrainBank:
            return CommodityBalanceType.GrainBank;
        case DeliveryMethod.WarehouseReceipts:
            return CommodityBalanceType.WarehouseReceipts;
        case DeliveryMethod.HouseReceipts:
            return CommodityBalanceType.HouseReceipts;
        case DeliveryMethod.ShortTermStorage:
            return CommodityBalanceType.ShortTermStorage;
        case DeliveryMethod.FarmDirect:
            return CommodityBalanceType.FarmDirect;
        default:
            return null;
    }
}

export function getDeliveryMethod(commodityBalanceType: CommodityBalanceType): DeliveryMethod | null {
    switch (commodityBalanceType) {
        case CommodityBalanceType.OpenStorage:
            return DeliveryMethod.OpenStorage;
        case CommodityBalanceType.DelayedPrice:
            return DeliveryMethod.DelayedPrice;
        case CommodityBalanceType.GrainBank:
            return DeliveryMethod.GrainBank;
        case CommodityBalanceType.WarehouseReceipts:
            return DeliveryMethod.WarehouseReceipts;
        case CommodityBalanceType.HouseReceipts:
            return DeliveryMethod.HouseReceipts;
        case CommodityBalanceType.ShortTermStorage:
            return DeliveryMethod.ShortTermStorage;
        case CommodityBalanceType.FarmDirect:
            return DeliveryMethod.FarmDirect;
        default:
            return null;
    }
}